import { useContext } from "react";
import TillAuthContext from "@contexts/TillAuthContext";

function useTillAuth() {
  return useContext(TillAuthContext);
}

export default useTillAuth;
